import { render, staticRenderFns } from "./ContactMessage.vue?vue&type=template&id=1d3dec49&"
import script from "./ContactMessage.vue?vue&type=script&lang=js&"
export * from "./ContactMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports